const BASE_URL = process.env.REACT_APP_STUDENT_API;


export async function getSSOredirct(){
    try{

        const response = await fetch(`${BASE_URL}/students/sso_login`);
        console.log(response)
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const redirect = await response.json();
        window.location=redirect
  
      }catch(error){
        console.error("Fetching SSO REDIRECT failed:", error);
      }
}

export async function getValidateUser(key){
    try{

        const response = await fetch(`${BASE_URL}/students/validate/${key}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const user = await response.json();
        return true
  
      }catch(error){
        return false
        console.error("Fetching SSO REDIRECT failed:", error);
      }
}